module.exports = __webpack_public_path__ + "img/employee-documents.beedb1e7.svg";